// noinspection ES6UnusedImports
import React from 'react';
import {createRoot} from 'react-dom/client';
import ConsentSessionStartStatusChecker from '@consent/scripts/components/ConsentSessionStartStatusChecker.jsx';
import JshModule from "@core/scripts/helper/jsh-module";

const {moduleScope} = JshModule('consent/consent-status-checker');
createRoot(moduleScope).render(<ConsentSessionStartStatusChecker/>);
